import classNames from "classnames"

import { ReactComponent as ErrorIcon } from "assets/icons/error.svg"

import styles from "./styles.module.scss"

interface IErrorLayout extends React.FC {
  Error: React.FC
  Title: React.FC
  Subtitle: React.FC
  Actions: React.FC
  Icon: React.FC
}
const ErrorLayout: IErrorLayout = ({ children }) => {
  return <div className={styles.container}>{children}</div>
}

ErrorLayout.Icon = ({ children }) => (
  <div className={styles.icon}>
    {children || (
      <ErrorIcon width="72" height="72" fill="var(--color-danger)" />
    )}
  </div>
)

ErrorLayout.Error = ({ children }) => (
  <p className={classNames(styles.error, "body-heavy")}>{children}</p>
)
ErrorLayout.Title = ({ children }) => (
  <h1 className={classNames(styles.pageTitle, "display-heavy")}>{children}</h1>
)
ErrorLayout.Subtitle = ({ children }) => (
  <p className={classNames(styles.pageSubtitle, "d")}>{children}</p>
)
ErrorLayout.Actions = ({ children }) => (
  <div className={styles.actions}>{children}</div>
)

export default ErrorLayout
